import { QueryHookOptions, useQuery } from '@apollo/client';

import { JobBoardDto, QueryGetGuestPotentialJobsArgs, QueryGetJobPositionScoreArgs } from '@pflegia/data-access';
import { useAuth } from '@pflegia/ui/contexts/auth.context';

import { GET_JOB_POSITIONS_LIST } from '@shared/graphql/operations/job-positions-list';
import { GET_NOT_LOGGED_JOB_POSITIONS_LIST } from '@shared/graphql/operations/not-logged-job-positions-list';

/**
 * Gets candidate / guest potential jobs.
 * Using one query can cause TS errors due to different variables.
 */
export const useGetPotentialJobs = (
  options: QueryHookOptions<{ data: JobBoardDto }, QueryGetJobPositionScoreArgs | QueryGetGuestPotentialJobsArgs>,
) => {
  const authenticated = useAuth();

  const candidateQuery = useQuery(GET_JOB_POSITIONS_LIST, {
    ...(options as QueryHookOptions<{ data: JobBoardDto }, QueryGetJobPositionScoreArgs>),
    skip: !authenticated || options.skip,
  });
  const guestQuery = useQuery(GET_NOT_LOGGED_JOB_POSITIONS_LIST, {
    ...(options as QueryHookOptions<{ data: JobBoardDto }, QueryGetGuestPotentialJobsArgs>),
    skip: authenticated || options.skip,
  });

  return authenticated ? candidateQuery : guestQuery;
};
